import InfoCard from './infoCard'
export default InfoCard
